import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaterialAssetService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  linkAssetToMaterial(
    materialId: number,
    payload: {
      mediaAssetId: number;
      sortOrder: number;
      role: string;
    }
  ) {
    return this.http.post(
      `${this.baseUrl}/v1/materials/${materialId}/assets`,
      payload
    );
  }

  getMaterialAssets(materialId: number) {
    return this.http.get(
      `${this.baseUrl}/v1/materials/${materialId}/assets`
    );
  }

  removeMaterialAsset(materialId: number, assetId: number) {
    return this.http.delete(
      `${this.baseUrl}/v1/materials/${materialId}/assets/${assetId}`
    );
  }
}